export interface RoleV2 {
  application: string;
  application_id: number;
  code: string;
  id: number;
  name: string;
  permissions: string[];
}

// AFS -> Advanced Flexpert Support

export enum RoleV2Id {
  PLATFORM_SUPER_ADMIN = 1,
  FAST_MK2_ADMIN = 7,
  FAST_MK2_REGIONAL_LEAD = 8,
  FAST_MK2_AFS = 9,
  FAST_MK2_RBAC_ADMIN = 14,
  FAST_MK2_RBAC_REGIONAL_LEAD = 15,
  FAST_MK2_RBAC_AFS = 16,
  FAST_MK2_FLEXPERT = 10,
  FAST_MK2_FLEXPERT_SUPPORT = 11,
  FAST_MK2_ADVANCED_PROVIDER = 17,
  FAST_MK2_BASIC_PROVIDER = 19,
}

export enum RoleV2Code {
  FAST_MK2_BASIC_PROVIDER = "FAST_MK2_BASIC_PROVIDER",
  FAST_MK2_ADVANCED_PROVIDER = "FAST_MK2_ADVANCED_PROVIDER",
  FAST_MK2_REGIONAL_LEAD = "FAST_MK2_REGIONAL_LEAD",
  FAST_MK2_AFS = "FAST_MK2_ADVANCED_FLEXPERT_SUPPORT",
}
